import AuthClient from './client';

const client = new AuthClient();

export const getAccessToken = () => client.getAccessToken();
export const isLoggedIn = () => client.isLoggedIn();
export const requestAccessToken = (code: string) =>
  client.requestAccessToken(code);
export const getUserID = () => client.getUserID();
export const requestAuthorisationURL = async () =>
  client.requestAuthorisationURL();
export const isTokenExpired = () => client.isTokenExpired();
export const requestClientSalesOrg = (token: string) =>
  client.requestClientSalesOrg(token);
export const getUserSalesOrgs = () => client.getUserSalesOrgs();
